import { useAgentTransport } from "@/agents/transport"

const formatBreadcrumb = (text: string): string => {
  return text
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

interface AgentBreadcrumbContentProps {
  agentId: string
  isLast: boolean
}

export const AgentBreadcrumbContent = ({
  agentId,
  isLast,
}: AgentBreadcrumbContentProps) => {
  const { data: agent } = useAgentTransport(agentId)

  const displayName = agent?.display_name

  return (
    <span className={isLast ? "font-semibold" : ""}>
      {displayName || formatBreadcrumb(agentId)}
    </span>
  )
}
